// extracted by mini-css-extract-plugin
export default {"wrap":"eF-z","subtitle":"fF-z","contentWrap":"gF-z","imgWrap":"hF-z","heading":"iF-z","copy":"jF-z"};